import { Alert, Col } from '@/components';
import { datetimeFormat } from '@/utils';
import { isPS } from '@/utils/system';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isDiscarded: boolean;
  isLocked: boolean;
  isPublished: boolean;
  publishedAt: string | null;
  lockedAt: string | null;
};

const DATE_FORMAT = 'YYYY/MM/DD HH:mm';

export const AlertColumns: FC<Props> = ({
  isDiscarded,
  isLocked,
  isPublished,
  publishedAt,
  lockedAt,
}) => {
  const { t } = useTranslation();

  return isPS() ? null : (
    <>
      {isDiscarded && (
        <Col span={24}>
          <Alert message={t('discarded-project')} type="error" />
        </Col>
      )}

      {isLocked && (
        <Col span={24}>
          <Alert
            message={
              lockedAt
                ? t('alert-message-locked-project-with-date', {
                    date: datetimeFormat({
                      datetime: lockedAt,
                      format: DATE_FORMAT,
                    }),
                  })
                : t('unknown-message-locked-project-with-date')
            }
            type="warning"
          />
        </Col>
      )}

      {isPublished && (
        <Col span={24}>
          <Alert
            message={
              publishedAt
                ? t('alert-message-published-project-with-date', {
                    date: datetimeFormat({
                      datetime: publishedAt,
                      format: DATE_FORMAT,
                    }),
                  })
                : t('alert-message-published-project')
            }
            type="warning"
          />
        </Col>
      )}
    </>
  );
};
